import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class DobleAutenticacionService{
    parametros: any;

    saveParametros(newParametros: any){
        this.parametros = newParametros;
    }

    getParametros(){
        return this.parametros;
    }
}
